import React from "react";
import "./BioPreviewSection.css";
import polishingImg from "../../imgs/services/polish.jpg";
import seatImg from "../../imgs/services/seats.jpg";
import { FaPhoneAlt } from "react-icons/fa";

function AboutSection() {
  return (
    <section className="detail-preview">
      <div className="detail-text">
        <p className="small-title">About Us</p>
        <h2 className="main-title">
          {/* Our Story<br /> */}
          <span className="highlight">Built From Passion and Experience</span>
        </h2>
        <p className="welcome">Professional Auto Detailing by People Who Care</p>
        <p className="description">
          John Wright and Glenn Spears are two "car guys" that have been in the business
          for many years! They decided to take their passion to the next level and start their
          own business. They will detail your car, boat, truck, bus, bike or anything else to
          make it a clean, shiny nice ride.
        </p>
        <div className="call-box">
          <div className="icon"><FaPhoneAlt /></div>
          <p>(763) 710-9136</p>
        </div>
      </div>

      <div className="image-stack">
        <img src={seatImg} alt="Seat" className="seat-img" loading="lazy" decoding="async" />
        <img src={polishingImg} alt="Polishing" className="polish-img" loading="lazy" decoding="async" />
      </div>
    </section>
  );
}

export default AboutSection;